var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "用户账号", prop: "userAcc" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "请输入用户账号" },
                model: {
                  value: _vm.childData.userAcc,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "userAcc", $$v)
                  },
                  expression: "childData.userAcc"
                }
              })
            ],
            1
          ),
          _vm.pwdVisable == true
            ? _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: { label: _vm.$t("table.userPwd"), prop: "userPwd" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      autocomplete: "new-password",
                      placeholder: "请输入用户密码",
                      type: "password"
                    },
                    model: {
                      value: _vm.childData.userPwd,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "userPwd", $$v)
                      },
                      expression: "childData.userPwd"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.posName") } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-item-width",
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.childData.posId,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "posId", $$v)
                    },
                    expression: "childData.posId"
                  }
                },
                _vm._l(_vm.postOption, function(item) {
                  return _c("el-option", {
                    key: item.posId,
                    attrs: { label: item.posName, value: item.posId }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.deptName"), prop: "upIdList" } },
            [
              _c("el-cascader", {
                staticClass: "form-item-width",
                attrs: {
                  options: _vm.options,
                  props: _vm.propstree,
                  "change-on-select": ""
                },
                model: {
                  value: _vm.childData.upIdList,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "upIdList", $$v)
                  },
                  expression: "childData.upIdList"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.userName"), prop: "userName" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.childData.userName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "userName", $$v)
                  },
                  expression: "childData.userName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.mobilephone") } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.childData.mobilephone,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "mobilephone", $$v)
                  },
                  expression: "childData.mobilephone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "身份证号" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.childData.userSerno,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "userSerno", $$v)
                  },
                  expression: "childData.userSerno"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.userState"), prop: "userState" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-item-width",
                  model: {
                    value: _vm.childData.userState,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "userState", $$v)
                    },
                    expression: "childData.userState"
                  }
                },
                _vm._l(_vm.userStateOption, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.aspRemark"),
                        prop: "aspRemark"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "490px" },
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.aspRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "aspRemark", $$v)
                          },
                          expression: "childData.aspRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "照片", prop: "files" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            name: "files",
                            "list-type": "picture-card",
                            headers: _vm.importHeaders,
                            "on-success": _vm.handleSuccess,
                            action: _vm.uploadUrl,
                            "on-preview": _vm.handlePreview,
                            "on-remove": _vm.handleRemove,
                            "before-remove": _vm.beforeRemove,
                            "before-upload": _vm.beforeUpload,
                            limit: 1,
                            "on-exceed": _vm.handleExceed,
                            "file-list": _vm.files
                          }
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            visible: _vm.dialogVisible,
                            "append-to-body": true,
                            title: "预览"
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.dialogVisible = $event
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.dialogImageUrl,
                              alt: ""
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.keyValue < 0 || _vm.keyValue === 0
        ? _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "margin-left": "50px",
                "line-height": "30px"
              }
            },
            [
              _c("div", [
                _vm._v(
                  " 密码必须同时包含大小写字母、数字、特殊字符，长度8-16位。 "
                )
              ]),
              _c("div", [_vm._v(" 另：数字不能连续三个及以上字符。 ")])
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }